import React, { useState } from 'react';
import Modal from '../ProfileV2/shared/Modal';
import { logCrmEvent } from '@javascripts/util/eventLogging';
import ExclamationCircle from '@images/exclamation_circle.svg';
import Icons from '@components/shared/icons';

import './styles.scss';

const AddressChangeModal = () => {

  const [isOpen, setIsOpen] = useState(true);

  const dismiss = () => {
    logCrmEvent('disruptor_dismissed', { type: 'us_bank_address_change' });
    setIsOpen(false);
  }

  const accept = () => {
    logCrmEvent('disruptor_submitted', { type: 'us_bank_address_change' });
    setIsOpen(false);
  }



  return (
    <Modal
      close={dismiss}
      id="address-change-modal"
      status={isOpen ? 'active' : 'hidden'}
    >
      <div className="close-container">
        <button
          type="button"
          className="close-button"
          onClick={dismiss}
        >
          <Icons type="close" />
        </button>
      </div>
      <div className="address-change-modal edit-modal-inner">
        <div className="address-change-header">
          <img src={ExclamationCircle} alt="notice" />
          <h2 className="headline-2">
            IMPORTANT:
            <br />
            Payment Information Update
          </h2>
        </div>
        <div className="address-changes">
          <p className="large-slim-font">
            <b>Effective immediately,</b> please direct all payments to our updated address and account information below:
          </p>
          <p className="large-slim-font">
            <b>Mailing Address (USPS Only)</b>
            <br />
            ReferralExchange, Inc.
            <br />
            PO Box 202532
            <br />
            Dallas, TX 75320-2532
          </p>
          <p className="large-slim-font">
            <b>FedEx / UPS Address</b>
            <br />
            Lockbox Services 202532
            <br />
            ReferralExchange, Inc.
            <br />
            2975 Regent Blvd, STE 100
            <br />
            Irving, TX 75063-3157
          </p>
          <p className="large-slim-font">
            <b>ACH/ Wire Transfer Information</b>
            <br />
            <b>Bank Name:</b> Wells Fargo Bank
            <br />
            <b>Account Name:</b> ReferralExchange, Inc.
            <br />
            <b>Account Number:</b> 4683343420
            <br />
            <b>Routing / ABA Number:</b> 121000248
            <br />
            <b>Wire Transfer SWIFT / IBAN:</b> WFBIUS6S
            <br />
            <b>Bank Address:</b> 333 Market Street, San Francisco, CA 94105
            <br />
          </p>
          <p className="large-slim-font">
            If you have any questions, please reach out to us at payments@referralexchange.com or give us a call at (415) 693-1430.
          </p>
        </div>
        <div className="button-container">
          <button
            id="address-change-acknowledged-button"
            type="submit"
            className="profile-edit-button large submit"
            onClick={accept}
          >
            Acknowledged
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AddressChangeModal;
